import BrokerCreationTemplate from "./BrokerCreationTemplate";
import { sortBrokerList } from "./BrokerSupport";
import PersonSelect from "./PersonSelect";
import Component from "components/Component";
import Disabled from "components/common/Disabled";
import { useSelector, useDispatch } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as peopleActions from "store/actions/people/peopleActions";
import { selectPersonByRole } from "store/selectors/people/peopleSelectors";

const usePeopleByRole = (role) => {
  const { data: peopleConfig, refetch } = staticDataService.useConfigQuery(
    "people"
  );
  const contacts = sortBrokerList(
    (peopleConfig?.all ?? []).filter((p) => p.roles?.includes(role))
  );
  return [contacts, refetch];
};

const ConfiguredPersonCreation = ({ type, onCreate, onClose }) => {
  const [contacts] = usePeopleByRole(type.role);
  const [
    createConfiguredPerson,
  ] = staticDataService.useCreateConfiguredPersonMutation();

  const createContact = (person) =>
    createConfiguredPerson({ role: type.role, ...person });

  return (
    <BrokerCreationTemplate
      brokers={contacts}
      createBroker={createContact}
      visibilityBaseTag={`<ConfiguredPerson:${type.role}>`}
      defaultVisibilityOverrideById={type.fields}
      fieldLabels={type.fieldLabels}
      formId={`configured-person-${type.role}-form`}
      title={`Add a new ${type.displayName}`}
      entityName={type.displayName}
      onCreate={onCreate}
      onClose={onClose}
    />
  );
};

const ConfiguredPersonField = ({ type }) => {
  const dispatch = useDispatch();
  const person = useSelector(selectPersonByRole(type.role));
  const [contacts, refetch] = usePeopleByRole(type.role);

  const updatePerson = (value) => {
    dispatch(peopleActions.updatePersonByType(type.role, value));
  };

  return (
    <Component title={type.displayName}>
      <Disabled ifReadOnly>
        <PersonSelect
          person={person}
          personList={contacts}
          onUpdatePerson={updatePerson}
          onUpdatePersonList={refetch}
          PersonCreationComponent={(props) => (
            <ConfiguredPersonCreation type={type} {...props} />
          )}
          label={type.displayName}
          showLabelOnCard
          createNewLabel={`Add new ${type.displayName}`}
        />
      </Disabled>
    </Component>
  );
};

const ConfiguredPeopleFields = () => {
  const { data: peopleTypesConfig } = staticDataService.useConfigQuery(
    "people_types"
  );
  const types = peopleTypesConfig?.types ?? [];

  if (types.length === 0) return null;

  return types.map((type) => (
    <ConfiguredPersonField key={type.role} type={type} />
  ));
};

export default ConfiguredPeopleFields;
